import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	padding: 32px;
	flex-direction: column;
`;

export const Header = styled.div`
	display: flex;
	width: 100%;
	padding: 16px 0;
`;

export const DimensionsWrapper = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
`;

export const TableList = styled.div`
	display: flex;
	flex-direction: column;
`;

export const NoData = styled.div`
	color: ${colors.grey5};
	border-top: 1px solid ${colors.grey3};
	padding: 16px;
	text-align: center;
	font-size: 19px;
	line-height: 27px;
`;

export const RadioWrapper = styled.div`
	padding-right: 32px;

	span + span {
		font-size: 16px;
		line-height: 24px;
	}
`;
